module.exports = __webpack_public_path__ + "static/media/congrat-page.13708b44.svg";